<script setup lang="ts">
import {Head, router, useForm} from "@inertiajs/vue3";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {route} from "ziggy-js";
import VFieldLabel from "@/components/forms/VFieldLabel.vue";

defineOptions({layout: AuthLayout})

interface Props {
    email: string
    token: string
}

const props = defineProps<Props>()

const form = useForm({
    email: props.email,
    token: props.token,
    password: '',
    password_confirmation: '',
})

const submit = () => {
    form.post(route('password.update'), {
        onFinish: () => {
            form.reset('password', 'password_confirmation')
        },
    })
}

const login = () => {
    router.visit(route('login'))
}
</script>

<template>
    <Head title="Reset Password ⋅ Capacity Framework Portal" />
    <v-card
        variant="flat"
        class="justify-center"
    >
        <v-form @submit.prevent="submit">
            <v-card-title class="text-center text-h4 text-pre-wrap">
                <p>
                    Reset your password
                </p>
                <p class="text-h5 text-medium-emphasis">
                    Enter your new password below.
                </p>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-field-label>
                    New password
                </v-field-label>
                <v-text-field
                    v-model="form.password"
                    type="password"
                    name="password"
                    autocomplete="new-password"
                    class="mb-3"
                    :hide-details="!form.errors.password"
                    :error-messages="form.errors.password"
                    autofocus
                />
                <v-field-label>
                    Confirm new password
                </v-field-label>
                <v-text-field
                    v-model="form.password_confirmation"
                    type="password"
                    name="password_confirmation"
                    autocomplete="new-password"
                    :hide-details="!form.errors.password_confirmation"
                    :error-messages="form.errors.password_confirmation"
                />
            </v-card-text>
            <v-card-actions class="mt-5">
                <v-btn
                    variant="flat"
                    type="submit"
                    :loading="form.processing"
                    block
                >
                    Reset Password
                </v-btn>
            </v-card-actions>
        </v-form>
        <p class="text-body-2 text-center mt-3">
            Already have an account? <span
                class="text-primary custom-link"
                @click="login"
            >
                Log in
            </span>
        </p>
    </v-card>
</template>

<style scoped>

</style>
